/**
 * URLs canoniques avec slash final (aligné sur scripts/url-canonical.mjs).
 */

export function canonicalPath(path: string): string {
  let p = String(path || '/').trim()
  if (!p.startsWith('/')) p = `/${p}`
  p = p.replace(/\/{2,}/g, '/')
  if (p !== '/' && !p.endsWith('/')) p = `${p}/`
  return p === '' ? '/' : p
}

export function buildAbsoluteCanonicalUrl(baseUrl: string, path: string): string {
  const base = baseUrl.replace(/\/+$/, '')
  return `${base}${canonicalPath(path)}`
}
